const cartTracking = {
    trackCartAction(action, gtmProductData, oldQuantity, newQuantity) {
        if (action == 'removeFromCart') {
            this.removeFromCart(gtmProductData, oldQuantity - newQuantity);
        } else {
            this.addToCart(gtmProductData, Math.abs(oldQuantity - newQuantity));
        }
    },
    addToCart(gtmProductData, qty) {
        dataLayer.push({
            'event':     'EECaddToCart',
            'ecommerce': {
                'currencyCode': gtmProductData.currencyCode,
                'add':          {
                    'products': [
                        {
                            'name':     gtmProductData.name,
                            'id':       gtmProductData.baseId,
                            'item_variant': gtmProductData.id,
                            'item_color': gtmProductData.color,
                            'item_size': gtmProductData.size,
                            'price':    gtmProductData.price !== undefined ? gtmProductData.price.toString() : undefined,
                            'brand':    gtmProductData.brand,
                            'category': `${gtmProductData.gtmGender}/${gtmProductData.categoryName}`,
                            'quantity': qty
                        }]
                }
            }
        });
        dataLayer.push({
            event:     'add_to_cart',
            ecommerce: {
                currency: gtmProductData.currencyCode,
                items:    [
                    {
                        'item_name':     gtmProductData.name,
                        'item_id':       gtmProductData.baseId,
                        'item_variant':  gtmProductData.id,
                        'item_color':    gtmProductData.color,
                        'item_size':     gtmProductData.size,
                        'price':         gtmProductData.price !== undefined ? gtmProductData.price.toString() : undefined,
                        'item_brand':    gtmProductData.brand,
                        'item_category': `${gtmProductData.gtmGender}/${gtmProductData.categoryName}`,
                        'item_category2': gtmProductData.category2 ?  gtmProductData.category2 : "",
                        'quantity':      qty
                    }]
            }
        });
    },
    removeFromCart(gtmProductData, qty) {
        dataLayer.push({
            'event':     'EECremoveFromCart',
            'ecommerce': {
                'remove': {
                    'products': [
                        {
                            'name':     gtmProductData.name,
                            'id':       gtmProductData.baseId,
                            'item_variant': gtmProductData.id,
                            'item_color': gtmProductData.color,
                            'item_size': gtmProductData.size,
                            'price':    gtmProductData.price !== undefined ? gtmProductData.price.toString() : undefined,
                            'brand':    gtmProductData.brand,
                            'category': `${gtmProductData.gtmGender}/${gtmProductData.categoryName}`,
                            'quantity': qty
                        }]
                }
            }
        });
        dataLayer.push({
            event:     'remove_from_cart',
            ecommerce: {
                currency: gtmProductData.currencyCode,
                items:    [
                    {
                        'item_name':     gtmProductData.name,
                        'item_id':       gtmProductData.baseId,
                        'item_variant':  gtmProductData.id,
                        'item_color':    gtmProductData.color,
                        'item_size':     gtmProductData.size,
                        'price':         gtmProductData.price !== undefined ? gtmProductData.price.toString() : undefined,
                        'item_brand':    gtmProductData.brand,
                        'item_category': `${gtmProductData.gtmGender}/${gtmProductData.categoryName}`,
                        'item_category2': gtmProductData.category2 ?  gtmProductData.category2 : "",
                        'quantity':      qty
                    }]
            }
        });
    },
};

export default cartTracking;
